import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ThemeService {
    private initialized: boolean = false;
    private _theme = signal<string>('');
    theme = this._theme.asReadonly();

    constructor() { }

    initTheme(theme: string | null | undefined) {
        if (this.initialized) return;

        const finalTheme = theme ? `${theme}-theme` : 'light-theme';
        this.applyThemeToBody(finalTheme);
        this._theme.set(finalTheme);
        this.initialized = true;
    }

    setTheme(theme: string) {
        this.applyThemeToBody(theme);
        this._theme.set(theme);
    }

    private applyThemeToBody(theme: string) {
        Array.from(document.body.classList)
            .filter(cls => cls.endsWith('-theme'))
            .forEach(cls => document.body.classList.remove(cls));

        document.body.classList.add(theme);
    }
}
